import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../../constants/constants';
export const componentKey = "Intermediary";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        updateAddIntermediaryDataObj: (state, action) => {
            let addIntermediaryDataObj = { ...state.addIntermediaryDataObj };

            Object.entries(action.payload).map(([key, value]) => {
                addIntermediaryDataObj = {
                    ...state.addIntermediaryDataObj,
                    [key]: {
                        ...state.addIntermediaryDataObj[key],
                        ...value,
                    },
                };

                state.addIntermediaryDataObj = addIntermediaryDataObj;
            })
        },
        setAddIntermediaryDataObjFieldsTouched: (state, action) => {
            state.addIntermediaryDataObj.allRequiredFieldsTouched = action.payload;
        },
        setIsSaveIntermediarySuccessful: (state, action) => {
            state.isSaveIntermediarySuccessful = action.payload;
        },
    }, 
    initialReducerState: {
        loadingState: { state: PAGE_STATE.PAGE_READY, message: "" },
        addIntermediaryDataObj: {
            allRequiredFieldsTouched: false,
            IntermediaryId: {
                value: "",
                errors: {},
                rules: {},
            },
            Name: {
                value: "",
                errors: {},
                rules: {required: true},
            },
            Address: {
                value: "",
                errors: {},
                rules: {},
            },
            City: {
                value: "",
                errors: {},
                rules: {},
            },
            StateorProvinceCode: {
                value: "",
                errors: {},
                rules: {},
            },
            ZipCode: {
                value: "",
                errors: {},
                rules: {},
            },
            TIN: {
                value: "",
                errors: {},
                rules: {},
            },
            CountryCode: {
                label: "",
                value: "",
                errors: {},
                rules: { required: true }
            },
            FTIN: {
                value: "",
                errors: {},
                rules: {}
            },
            GIIN: {
                value: "",
                errors: {},
                rules: {}
            },
        },
        isSaveIntermediarySuccessful: false,
    }
});
export const {
    setLoadingState,
    updateAddIntermediaryDataObj,
    setAddIntermediaryDataObjFieldsTouched,
    setIsSaveIntermediarySuccessful,
} = actions;